module.exports = __webpack_public_path__ + "static/intertec_logo_new-cbfde2f7c3e0e53427b160cc96aa4860.jpg";